/** Padder */
const pad = (num, d) => (Math.pow(10, d) + Number(num)).toString().substring(1, d)

/** Month in English */
const monthsEng = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug','Sep', 'Oct', 'Nov', 'Dec']
const monthsEngFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August','September', 'October', 'November', 'December']

export default {
  name: 'OctBase',
  methods: {
    /** Convert date object into string */
    dateObjectToString (val) {
      // Create date and convert it
      return this.dateToString(new Date(val.year, val.month-1, val.date))
    },
    /** Convert date into string */
    dateToString (val, verbose=false) {
      // Ignore invalid date
      if (isNaN(val.getFullYear())) return ''

      return `${[...(verbose ? monthsEngFull : monthsEng)][val.getMonth()]} ${val.getDate()}, ${val.getFullYear()}`
    },
    /** Return locale string of specified property */
    getLocaleString (item, property) {
      item = item || this

      //const en = item[`${property}EN`]
      const ja = item[property]

      //return ja && ja || en
      return ja
    },
    /**
     * Convert size object into string
     * @param {object} item - A size object
     * @param {string} unit - Unit of size description
     */
    sizeToString (item, unit='cm') {
      // Avoid invalid item
      if (!item) return ''

      // Ratio compare to cm scale
      const ratio = unit === 'cm' ? 1 : 1/2.5
      // Convert object into array
      const size = Object.values(item).reduce((acc, cur) => {
        cur && acc.push(cur*ratio)
        return acc
      }, [])

      // Avoid invalid item
      if (!size.length) return ''

      // Join size by '×' and add unit
      return `${size.join(' × ')} ${unit}`
    },
    /**
     * Convert period into string
     * @param {date} from - Period from
     * @param {date} to - Period to
     * @param {boolean} verbose - Whether to use long labels
     */
    periodToString (from, to, verbose=false) {
      // Output array or strings
      [from, to] = [from, to].map(item => {
        // Ignore invalid input
        if (!item || isNaN(item.getFullYear()) || item.getFullYear() === 1970)
          return ['', '', '']
        
        return [
          [...(verbose && monthsEngFull || monthsEng)][item.getMonth()] + ' ',
          this.pad(item.getDate(), 2),
          ', ' + item.getFullYear()
        ]
      })

      // Invalid period
      if (!from[0] && !to[0]) return ''

      // Organize output arrays
      from[2] === to[2] && from.pop()
      from[0] === to[0] && from.shift()

      return `${from.join('')} – ${to.join('')}`
    },
    /**
     * Analyze relationship between date and period
     * @param {date} from - From date of period to analyze
     * @param {date} to - To date of period to analyze
     * @param {date} date - A date to analyze
     * @return {number} 0: The day is in the period, 1: The day is after the period, -1: The day is before the period
     */
    analyzeDateAndPeriod (from, to, date=new Date) {
      // Normalize argumants
      [from, to, date] = [from, to, date].map((item, i) => {
        return ((!item || isNaN(item.getFullYear()) || item.getFullYear() === 1970) ?
          (i === 0 ? new Date(0) : new Date(3000, 0, 1)) : item).getTime()
      })

      // Compare date
      return date < from ? -1 : (date > to ? 1 : 0)
    },
    pad: pad
  }
}